<template>
	<div class="landing">
		<v-container fluid class="text-center banner1 d-flex flex-column align-center justify-center">
			<div class="right floating-img"></div>
			<div class="left floating-img"></div>
			<h1 class="primary--text font-weight-bold fs-h1 ff-emkan-bold">{{ businessTitle }}</h1>
			<p class="orange--text pt-4 fs-h3">تنها پلتفرم آنلاین با بیش از ۲۰ طرح آنلاین</p>
		</v-container>
		<v-container class="text-center mt-12">
			<v-row justify="center" class="mt-10">
				<v-col cols="12" sm="4" class="text-center">
					<div class="primary--text fs-h3">تنوع بالای کالاها</div>
					<v-img src="/NafisTheme/products.webp" contain max-height="300" :alt="`${businessTitle}-تنوع بالای کالاها`" />
				</v-col>
				<v-col cols="12" sm="4" class="text-center">
					<div class="primary--text fs-h3">بدون ضامن</div>
					<v-img src="/NafisTheme/no-guarantor.webp" contain max-height="300" :alt="`${businessTitle}-بدون ضامن`" />
				</v-col>
				<v-col cols="12" sm="4" class="text-center">
					<div class="primary--text fs-h3">فوری و آنلاین</div>
					<v-img src="/NafisTheme/fast.webp" contain max-height="300" :alt="`${businessTitle}-فوری و آنلاین`" />
				</v-col>
			</v-row>
		</v-container>

		<!-- اسلایدر طرح‌ها -->
		<v-container class="mt-12">
			<div v-if="loanLoading">
				<v-progress-linear :size="4" color="primary" indeterminate />
				<div class="mt-2 info--text text-center">در حال دریافت اطلاعات طرح ها ...</div>
			</div>
			<div v-else>
				<v-alert v-if="!plans || !plans.length" color="info" outlined>در حال حاضر هیچ طرح فعالی در دسترس نمی باشد</v-alert>
				<v-row v-else v-for="(plan, i) in plans" :key="i" class="plan-carousel mb-8">
					<v-col cols="12" sm="4" class="d-flex align-center px-0 py-0 justify-end" :class="[i % 2 === 0 ? 'order-sm-1' : 'order-sm-2']">
						<v-sheet color="orange lighten-2" class="white--text rounded-xl d-flex align-center plan-title fs-h4 ff-emkan-bold" :class="[i % 2 === 0 ? 'pull-left no-pull-sm' : 'pull-right no-pull-sm']" height="50" elevation="0">{{ plan.tag }}</v-sheet>
					</v-col>
					<v-col cols="12" sm="8" class="px-0 py-0" :class="[i % 2 === 0 ? 'order-sm-2' : 'order-sm-1']">
						<v-carousel hide-delimiters height="160" class="rounded-xl">
							<v-carousel-item v-for="loan in plan.loans" :key="loan.id">
								<v-sheet class="primary lighten-1 plan-body" height="160">
									<div class="d-flex align-center justify-center fs-h3 h-100">
										{{ loan.title }}
									</div>
								</v-sheet>
							</v-carousel-item>
						</v-carousel>
					</v-col>
				</v-row>
			</div>
		</v-container>

		<!-- بخش توضیح -->
		<v-container class="mt-12">
			<v-row>
				<v-col cols="12" md="6">
					<v-img src="/NafisTheme/man.webp" max-width="100%" :alt="`${businessTitle}-خرید اقساطی بدون ضامن`" />
				</v-col>
				<v-col cols="12" md="6">
					<h2 class="primary--text fs-h2 gradient-text">{{ businessTitle }}، خرید اقساطی بدون ضامن</h2>
					<p class="text-body-2 py-8 px-3 text-justify" style="line-height: 35px;">
						با {{ businessTitle }}، دیگر دغدغه پرداخت نقدی نخواهید داشت. ما با ارائه طرح های متنوع عتباری، این امکان را فراهم کرده ایم تا
						بدون نیاز به ضامن، بتوانید کالاهای مورد نیاز خود از جمله لوازم خانگی، موبایل، لب تاپ، کالاهای دیجیتال و سایر خدمات را به صورت
						قسطی تهیه کنید.
						<br />
						<b>{{ businessTitle }} همراه مطمئن شما در مسیر خرید آسان.</b>
					</p>
				</v-col>
			</v-row>
		</v-container>

		<!-- چگونه خرید اعتباری کنم -->
		<v-container class="mt-10">
			<h2 class="text-center font-weight-bold mb-6 fs-h2">چطور اعتباری خرید کنم؟</h2>
			<h2 class="primary--text mb-6 fs-h3 text-center">فقط در 4 مرحله و بدون مراجعه حضوری ، اعتبار بگیرید و خرید کنید.</h2>
			<v-row justify="center" class="mt-4">
				<v-col cols="12" sm="6" md="3" v-for="(step, i) in steps" :key="i">
					<v-card outlined class="h-100 gradient-border">
						<v-card-text class="text-center pa-3 px-6">
							<v-img :src="step.icon" height="60" contain class="my-5" :alt="`${businessTitle}-چطور اعتباری خرید کنم`" />
							<h4 class="my-3 fs-h4 primary--text">{{ step.title }}</h4>
							<p class="text-justify fs-h6 black--text" style="line-height: 25px;">{{ step.desc }}</p>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- بخش توضیح2 -->
		<v-container fluid class="mt-3">
			<v-row>
				<v-col cols="12" class="d-flex justify-center">
					<v-img src="/NafisTheme/tim.webp" contain max-height="450px" />
				</v-col>
			</v-row>
			<v-sheet color="primary lighten-3" class="py-10">
				<v-container class="">
					<v-row>
						<v-col cols="12" sm="4">
							<v-card class="pa-10 rounded-tl-xl rounded-br-xl mx-6" flat color="white">
								<div style="height:130px"></div>
								<div class="text-center">
									<v-btn class="rounded-tl-xl rounded-br-xl gradient-background" elevation="0" style="min-width: 100px;"></v-btn>

								</div>
							</v-card>
						</v-col>
						<v-col cols="12" sm="4">
							<v-card class="pa-10 rounded-tl-xl rounded-br-xl mx-6" flat color="white">
								<div style="height:130px"></div>
								<div class="text-center">
									<v-btn class="rounded-tl-xl rounded-br-xl gradient-background" elevation="0" style="min-width: 100px;"></v-btn>

								</div>
							</v-card>

						</v-col>
						<v-col cols="12" sm="4">
							<v-card class="pa-10 rounded-tl-xl rounded-br-xl mx-6" flat color="white">
								<div style="height:130px"></div>
								<div class="text-center">
									<v-btn class="rounded-tl-xl rounded-br-xl gradient-background" elevation="0" style="min-width: 100px;"></v-btn>

								</div>

							</v-card>

						</v-col>
					</v-row>
				</v-container>
			</v-sheet>
		</v-container>


		<!-- نظرات کاربران -->
		<v-container class="mt-10" style="margin-bottom: 150px;">
			<h2 class="text-center mb-6 fs-h2 primary--text">همراهان {{ businessTitle }}</h2>
			<v-carousel delimiter-icon="mdi-minus" hide-delimiter-background height="200" class="comment-carousel">
				<v-carousel-item v-for="(group, i) in groupedItems" :key="i" color="white">
					<v-row>
						<v-col cols="12" md="6" v-for="(item, j) in group" :key="j">
							<v-card class="pa-5 mt-6" :class="{ 'gradient-background': j === 0 }" color="white" height="165" style="box-shadow: rgb(255, 181, 244) 0px 0px 20px;margin: 10px;">
								<v-card-text>
									<v-avatar class="avatar" color="white">
										<img :src="`/NafisTheme/${item.avatar}`" :alt="`${businessTitle}-همراهان ما`">
									</v-avatar>
									<p class="text-justify py-6">{{ item.comment }}</p>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-carousel-item>
			</v-carousel>
		</v-container>

	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import router from '@/router'
	import { setCookie, getCookie } from '@/util/helpers'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'NafisThemePlansView',
		components: {
			'loan-calculator': () => import('@/components/LoanCalculator'),
		},
		data: () => ({
			steps: [
				{ title: 'ثبت نام و دریافت اعتبار', icon: '/NafisTheme/step1.jpg', desc: `در لندتک نفیس به سادگی ثبت نام و پس از فرآیند اعتبارسنجی بانکی، درخواست اعتبار کنید.` },
				{ title: 'بارگذاری و ارسال مدارک', icon: '/NafisTheme/step2.jpg', desc: 'مدارک مورد نیاز را در پنل کاربری خود بارگذاری کنید. پس از تایید مدارک، نسخه فیریکی آن را ارسال کنید.' },
				{ title: 'دریافت اعتبار', icon: '/NafisTheme/step3.jpg', desc: `پس از تایید مدارک، اعتبار به کیف شما در لندتک نفیس اضافه می شود` },
				{ title: 'خرید اقساطی', icon: '/NafisTheme/step4.jpg', desc: `می توانید محصول مورد نظر خود را از فروشگاه لندتک نفیس به صورت قسطی خریداری کنید.` },
			],
			comments: [
				{ comment: 'خرید راحت، بدون ضامن، واقعا تجربه خوبی بود.', avatar: 'dummy-profile.png' },
				{ comment: 'فرآیند سریع و آسان، ممنون از خدماتتون!', avatar: 'dummy-profile.png' },
				{ comment: 'فرآیند سریع و آسان', avatar: 'dummy-profile.png' },
				{ comment: 'اسلاید 4', avatar: 'dummy-profile.png' },
				{ comment: 'اسلاید 5!', avatar: 'dummy-profile.png' }
			],
			loanLoading: false,
			loans: []
		}),
		computed: {
			...get('auth', [
				'isMember', 'getCurrentUser'
			]),
			...get('siteConfig', [
				'isCloud', 'fullTitle'
			]),
			...get('appSettings', [
				'landingSettings'
			]),
			authorizations() {
				return this.loanRequest.loanModel?.loanAuthorizationItems || []
			},
			businessTitle() {
				return this.landingSettings?.businessTitle || this.fullTitle
			},
			phone() {
				return this.landingSettings?.phones
			},
			agentOfficePhone() {
				return this.landingSettings?.agentOfficePhone
			},
			groupedItems() {
				const groupSize = this.$vuetify.breakpoint.smAndDown ? 1 : 2
				return this.comments.reduce((groups, item, index) => {
					if (index % groupSize === 0) {
						groups.push([])
					}
					groups[groups.length - 1].push(item)
					return groups
				}, [])
			},
			plans() {
				if (!this.loans?.length)
					return []
				const publicKeyName = 'سایر طرح ها'
				let groups = []
				for (let loan of this.loans) {
					if ((loan.tags || []).some(t => t.isPublic)) {
						(loan.tags || []).map(tag => {
							let index = groups.findIndex(x => x.tag === tag.title)
							if (index === -1)
								groups.push({ tag: tag.title, loans: [loan] })
							else
								groups[index].loans.push(loan)
						})
					} else {
						let index = groups.findIndex(x => x.tag === publicKeyName)
						if (index === -1)
							groups.push({ tag: publicKeyName, loans: [loan] })
						else
							groups[index].loans.push(loan)
					}
				}
				return groups
			}
		},
		mounted() {
			this.customerCode = this.$route.params.customerCode || 0
			this.loadLoans()
		},
		methods: {
			loadLoans() {
				this.loanLoading = true
				return api.get('loan/list/' + this.customerCode, null, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.loans = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loanLoading = false
					})
			},
			submitRequest() {
				if (!this.loanRequest.loanModel) {
					this.loanRequestMessage = 'ابتدا طرح خرید اقساطی را انتخاب کنید.'
					return
				}
				if (!this.isMember) {
					window.localStorage.setItem("loanrequest", JSON.stringify(this.loanRequest))
					router.push({ name: 'Register', params: { customerCode: this.customerCode } }).catch(() => { })
					return
				}
				this.submitRequestLoading = true
				this.loanRequestMessage = ''
				api.post('member/userLoanRequest/create', this.loanRequest)
					.then(response => {
						router.replace('/member/LoanRequest/' + response).catch(() => { })
					})
					.catch(err => {
						this.loanRequestMessage = err.message
					})
					.finally(() => {
						this.submitRequestLoading = false
					})
			},
			selectLoan(loan) {
				this.loanRequest.loanModel = loan
			},
			scrollToCalculator() {
				document.getElementById("calculator").scrollIntoView()
			}
		},
	}
</script>

<style lang="scss">

	h1,
	h2,
	h3 {
		font-family: 'Yekan', sans-serif;
	}

	.landing {
		.fs-h1 {
			font-size: 3.055rem !important;
		}

		.fs-h2 {
			font-size: 2.25rem !important;
		}

		.fs-h3 {
			font-size: 1.5625rem !important;
		}

		.fs-h4 {
			font-size: 1.125rem !important;
		}

		.fs-h5 {
			font-size: 0.85rem !important;
		}

		.fs-h6 {
			font-size: 0.75rem !important;
		}

		.fs-subtitle-1 {
			font-size: 0.875rem !important;
		}

		.fs-subtitle-2 {
			font-size: 0.875rem !important;
		}

		.fs-caption {
			font-size: 0.8125rem !important;
		}

		.banner1 {
			height: 300px;
			position: relative;
			overflow: visible;
			z-index: 0;

			.right {
				position: absolute;
				background-image: url('/NafisTheme/banner1-right.webp');
				width: 25%;
				height: 100%;
				top: 0;
				right: 0;
				z-index: 0;
				background-size: contain;
				background-position-x: right;
			}

			.left {
				position: absolute;
				background-image: url('/NafisTheme/banner1-left.webp');
				width: 35%;
				height: 100%;
				top: 0;
				left: 0;
				z-index: 0;
				background-size: contain;
				background-position-x: left;
			}
		}

		.plan-carousel {
			.plan-title {
				width: 100%;
				position: relative;
				z-index: 1;
				padding: 0 10px;
				text-align: center;

				&.pull-right {
					right: -57px;
					padding-right: 50px;
				}

				&.pull-left {
					left: -57px;
					padding-left: 25px;
				}
			}

			.plan-body {
				background-image: url('/NafisTheme/plan-bg.jpg');
				background-size: cover;
			}
		}

		.gradient-text {
			background: linear-gradient(90deg, #f8b4f0, #88aeff, #84e2fe);
			/* رنگ گرادینت */
			-webkit-background-clip: text;
			/* متن فقط بخش پس‌زمینه رو نشون بده */
			-webkit-text-fill-color: transparent;
			/* متن رو شفاف کن تا فقط گرادینت دیده بشه */
		}

		.gradient-border {
			background: linear-gradient(white, white),
				linear-gradient(to bottom, #84e2fe, #88aeff, #f8b4f0);
			background-origin: padding-box, border-box;
			background-clip: padding-box, border-box;
			border: 2px solid transparent;
		}

		.gradient-background {
			background: linear-gradient(to right, #84e2fe, #88aeff, #f8b4f0);
		}

		.comment-carousel {
			overflow: visible;
		}

		.comment-carousel .v-carousel__controls {
			position: absolute;
			bottom: -45px;
			left: 50% !important;
			transform: translateX(-50%);
			background: transparent;
		}

		/* دلیمیتِر غیرفعال */
		.comment-carousel .v-carousel__controls .v-btn {
			margin: 0 4px;
			opacity: 0.6;
		}

		.comment-carousel .v-carousel__controls .v-btn__content {
			color: #888;
		}

		/* دلیمیتِر فعال */
		.comment-carousel .v-carousel__controls .v-btn--active,
		.comment-carousel .v-carousel__controls .v-btn--active .v-btn__content {
			opacity: 1;
			color: blue;
		}


		.comment-carousel .v-carousel__controls .v-btn__content i {
			font-size: 25px !important;
		}

		.comment-carousel P {
			color: purple
		}

		.comment-carousel .gradient-background P {
			color: white
		}

		.comment-carousel .avatar {
			position: absolute;
			top: -24px;
			left: 0;
			right: 0;
			width: 50px;
			margin: auto;
			border: 1px solid #ddd !important;
		}
	}

	@media screen and (max-width: 600px) {
		.no-pull-sm {
			right: 0 !important;
			left: 0 !important;
		}
	}

	@keyframes floatUpDown {
		0% {
			transform: translateY(0);
		}

		50% {
			transform: translateY(-10px);
		}

		100% {
			transform: translateY(0);
		}
	}

	.floating-img {
		animation: floatUpDown 4s cubic-bezier(0.4, 0.0, 0.6, 1) infinite;
	}

</style>